<template>
  <div class="div">
    <div class="row">
      <div class="col-12">
        <h1 class="text-center mb-3">
          {{ this.selectedCity }}
          <small class="text-muted d-block">{{ getCityCountry }}</small>
        </h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mb-4">
        <b-button @click="selectCity('none')" class="btn-link border-0"
          >Back to <span class="font-weight-700">all cities</span>
        </b-button>
      </div>
    </div>

    <div class="row row-grid align-items-center mt-0">
      <div class="col-md-5 order-md-2 text-center">
        <div
          class="city-image-placeholder"
          style="
            padding: 3em;
            max-width: 400px;
            width: 100%;
            background: #f8f9fa;
            border-radius: 10px;
            min-height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div class="text-center">
            <i class="ni ni-building text-muted" style="font-size: 4rem"></i>
            <p class="text-muted mt-2">
              {{ selectedCityData?.city || selectedCity }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-7 order-md-1">
        <div class="bg-lightgrey country-container">
          <div class="row">
            <div class="col-md-6">
              <div class="report-stat-box-header">
                <div class="field-name">Population</div>
                <div class="field-value">
                  {{ formatNumber(selectedCityData?.population) }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="report-stat-box-header">
                <div class="field-name">GDP per Capita</div>
                <div class="field-value">
                  ${{ formatNumber(selectedCityData?.gdp_per_capita) }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="report-stat-box">
                <div class="field-name">Income Group</div>
                <div class="field-value">
                  {{ selectedCityData?.income_group }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="report-stat-box">
                <div class="field-name">Region</div>
                <div class="field-value">{{ selectedCityData?.region }}</div>
              </div>
            </div>
          </div>

          <ul class="list-unstyled mt-2"></ul>
        </div>
      </div>
    </div>

    <div class="col-12 text-center mb-4">
      <b-button @click="selectCity('none')" class="btn-link border-0"
        >Click here to view the
        <span class="font-weight-700">What Ifs</span> section
      </b-button>
    </div>

    <div
      class="col-12 text-center"
      :class="'selected-pillar-' + selectedPillar"
    >
      <div class="row">
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('future_readiness')"
          class="col-12 total-future-readiness text-center pillar-total"
        >
          <p class="pillar-name">Future Readiness Score</p>
          <p class="pillar-value">
            {{ selectedCityData?.future_readiness_score.toFixed(2)
            }}<span class="rank">
              (#{{ selectedCityData?.future_readiness_rank }})</span
            >
          </p>
        </div>
      </div>
      <div class="row sub-pillars">
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('people_centricity')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-people_centricity mx-1 my-2">
            <p class="pillar-name">People Centricity</p>
            <p class="pillar-value">
              {{ selectedCityData?.people_centricity_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.people_centricity_rank }})</span
              >
            </p>
          </div>
        </div>
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('openness')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-openness mx-1 my-2">
            <p class="pillar-name">Openness</p>
            <p class="pillar-value">
              {{ selectedCityData?.openness_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.openness_rank }})</span
              >
            </p>
          </div>
        </div>
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('sustainability')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-sustainability mx-1 my-2">
            <p class="pillar-name">Sustainability</p>
            <p class="pillar-value">
              {{ selectedCityData?.sustainability_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.sustainability_rank }})</span
              >
            </p>
          </div>
        </div>
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('institutions_governance')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-institutions_governance mx-1 my-2">
            <p class="pillar-name">Institutions & Governance</p>
            <p class="pillar-value">
              {{ selectedCityData?.institutions_governance_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.institutions_governance_rank }})</span
              >
            </p>
          </div>
        </div>
      </div>

      <div class="row sub-pillars">
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('transport_infrastructure')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-transport_infrastructure mx-1 my-2">
            <p class="pillar-name">Transport & Infrastructure</p>
            <p class="pillar-value">
              {{ selectedCityData?.transport_infrastructure_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.transport_infrastructure_rank }})</span
              >
            </p>
          </div>
        </div>
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('innovation')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-innovation mx-1 my-2">
            <p class="pillar-name">Innovation</p>
            <p class="pillar-value">
              {{ selectedCityData?.innovation_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.innovation_rank }})</span
              >
            </p>
          </div>
        </div>
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('vibrancy')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-vibrancy mx-1 my-2">
            <p class="pillar-name">Vibrancy</p>
            <p class="pillar-value">
              {{ selectedCityData?.vibrancy_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.vibrancy_rank }})</span
              >
            </p>
          </div>
        </div>
        <div
          @mouseleave="hoverPillar('none')"
          @mouseover="hoverPillar('e_intelligence')"
          class="col-3 text-center p-0 m-0"
        >
          <div class="pillar-total total-e_intelligence mx-1 my-2">
            <p class="pillar-name">E-Readiness</p>
            <p class="pillar-value">
              {{ selectedCityData?.e_intelligence_score.toFixed(2)
              }}<span class="rank">
                (#{{ selectedCityData?.e_intelligence_rank }})</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 p-0" style="overflow: scroll">
      <template>
        <div>
          <!-- Sub-pillar details can be added here if needed -->
          <div v-if="selectedPillar !== 'none'" class="mt-4">
            <h3 class="text-center mb-3">
              {{ getPillarDisplayName(selectedPillar) }} Details
            </h3>

            <!-- Sub-pillars table would go here -->
            <div v-if="selectedPillar === 'people_centricity'" class="row">
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Liveability</div>
                  <div class="field-value">
                    {{ selectedCityData?.liveability_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.liveability_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Access to Services</div>
                  <div class="field-value">
                    {{ selectedCityData?.access_to_services_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.access_to_services_rank }})</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedPillar === 'openness'" class="row">
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Investment Openness</div>
                  <div class="field-value">
                    {{
                      selectedCityData?.investment_openness_score.toFixed(2)
                    }}
                    <span class="rank"
                      >(#{{ selectedCityData?.investment_openness_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Talent Competitiveness</div>
                  <div class="field-value">
                    {{
                      selectedCityData?.talent_competitiveness_score.toFixed(2)
                    }}
                    <span class="rank"
                      >(#{{
                        selectedCityData?.talent_competitiveness_rank
                      }})</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedPillar === 'sustainability'" class="row">
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Urban Design</div>
                  <div class="field-value">
                    {{ selectedCityData?.urban_design_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.urban_design_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Energy & Waste</div>
                  <div class="field-value">
                    {{ selectedCityData?.energy_waste_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.energy_waste_rank }})</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="selectedPillar === 'institutions_governance'"
              class="row"
            >
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Institutions</div>
                  <div class="field-value">
                    {{ selectedCityData?.institutions_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.institutions_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Governance</div>
                  <div class="field-value">
                    {{ selectedCityData?.governance_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.governance_rank }})</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="selectedPillar === 'transport_infrastructure'"
              class="row"
            >
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Mobility</div>
                  <div class="field-value">
                    {{ selectedCityData?.mobility_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.mobility_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Digital Infrastructure</div>
                  <div class="field-value">
                    {{
                      selectedCityData?.digital_infrastructure_score.toFixed(2)
                    }}
                    <span class="rank"
                      >(#{{
                        selectedCityData?.digital_infrastructure_rank
                      }})</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedPillar === 'innovation'" class="row">
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">R&D Intensity</div>
                  <div class="field-value">
                    {{ selectedCityData?.rd_intensity_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.rd_intensity_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">IP Intensity</div>
                  <div class="field-value">
                    {{ selectedCityData?.ip_intensity_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.ip_intensity_rank }})</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedPillar === 'vibrancy'" class="row">
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Financial Activity</div>
                  <div class="field-value">
                    {{ selectedCityData?.financial_activity_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.financial_activity_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Cultural Vibrancy</div>
                  <div class="field-value">
                    {{ selectedCityData?.cultural_vibrancy_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.cultural_vibrancy_rank }})</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedPillar === 'e_intelligence'" class="row">
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">Data Readiness</div>
                  <div class="field-value">
                    {{ selectedCityData?.data_readiness_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.data_readiness_rank }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="report-stat-box">
                  <div class="field-name">AI Readiness</div>
                  <div class="field-value">
                    {{ selectedCityData?.ai_readiness_score.toFixed(2) }}
                    <span class="rank"
                      >(#{{ selectedCityData?.ai_readiness_rank }})</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import citiesData from "../../data_2025/cities.json";
import cityWhatIfDataMaximums from "../../data_2025/what-ifs/cityWhatIfDataMaximums.json";

export default {
  name: "WhatIfsTableCity",
  components: {
    BButton,
  },
  props: {
    selectedCity: {
      default: null,
    },
  },
  data() {
    return {
      citiesData: citiesData,
      selectedPillar: "none",
      scenario: "current",
      cityWhatIfDataMaximums: cityWhatIfDataMaximums,
    };
  },

  computed: {
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    selectedCitySlug() {
      if (typeof this.selectedCity === "string") {
        return this.selectedCity
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]/g, "");
      }
      return this.selectedCity;
    },
    selectedCityData() {
      return (
        this.citiesData[this.selectedCitySlug] ||
        this.citiesData[this.selectedCity]
      );
    },
    getCityCountry() {
      return this.selectedCityData?.country || "Unknown Country";
    },
    cityWhatIfDataMaximumsForGivenScenario() {
      return this.cityWhatIfDataMaximums[this.scenario];
    },
  },
  methods: {
    backgroundColor(value, key) {
      return "pillar " + key;
    },
    hoverPillar(pillar) {
      this.selectedPillar = pillar;
    },
    selectCity(city) {
      this.$emit("clickedCity", city);
    },
    formatNumber(number) {
      if (!number) return "N/A";
      return new Intl.NumberFormat().format(Math.round(number));
    },
    getPillarDisplayName(pillar) {
      const pillarNames = {
        future_readiness: "Future Readiness",
        people_centricity: "People Centricity",
        openness: "Openness",
        sustainability: "Sustainability",
        institutions_governance: "Institutions & Governance",
        transport_infrastructure: "Transport & Infrastructure",
        innovation: "Innovation",
        vibrancy: "Vibrancy",
        e_intelligence: "e-Intelligence",
      };
      return pillarNames[pillar] || pillar;
    },
  },
};
</script>

<style>
.what-if-buttons {
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center;
}

.what-if-buttons .form-group {
  width: 100%;
}

.rankingsTable th:focus {
  outline: 0;
}

.rank {
  background: none !important;
  font-weight: bold;
  margin-top: 5px;
  font-size: 0.8em;
  color: #666;
}

.rankingsTable th {
  border-top: solid 5px #fff !important;
  text-align: center;
}

.rankingsTable th:nth-child(2)[aria-sort="descending"] {
  border-top: solid 5px #3ac7ffff !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(2)[aria-sort="ascending"] {
  border-top: solid 5px #3ac7ffff !important;
  background: #fbfbfb;
}

.pillar-total {
  transition: all 0.1s ease-in-out;
  padding: 1em 0 1em 0;
  min-height: 98px;
}

.th-header {
  text-align: left !important;
  border: none !important;
  background: #fafafa;
}

.pillar-name {
  margin: 0;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 500;
  line-height: 17px;
}

.pillar-value {
  font-size: larger;
  font-weight: bold;
  margin: 0;
}

.total-future-readiness {
  color: #4a4a4a;
  background: #fafafa;
  padding: 1.5em 0 1.5em 0;
}

.selected-pillar-future_readiness .total-people_centricity {
  background: rgba(78, 129, 196, 1);
  cursor: pointer;
  color: white;
}

.selected-pillar-future_readiness .total-openness {
  background: rgba(102, 173, 93, 1);
  cursor: pointer;
  color: white;
}

.selected-pillar-future_readiness .total-sustainability {
  background: rgba(226, 170, 35, 1);
  cursor: pointer;
  color: white;
}

.selected-pillar-future_readiness .total-institutions_governance {
  background: rgba(115, 51, 155, 1);
  cursor: pointer;
  color: white;
}

.selected-pillar-future_readiness .total-transport_infrastructure {
  background: rgba(204, 76, 42, 1);
  cursor: pointer;
  color: white;
}

.selected-pillar-future_readiness .total-innovation {
  background: rgba(243, 156, 18, 1);
  cursor: pointer;
  color: white;
}

.selected-pillar-future_readiness .total-vibrancy {
  background: rgba(39, 174, 96, 1);
  cursor: pointer;
  color: white;
}

.selected-pillar-future_readiness .total-e_intelligence {
  background: rgba(142, 68, 173, 1);
  cursor: pointer;
  color: white;
}

.total-people_centricity {
  color: rgba(78, 129, 196, 1);
  background: #fafafa;
}

.total-openness {
  color: rgba(102, 173, 93, 1);
  background: #fafafa;
}

.total-sustainability {
  color: rgba(226, 170, 35, 1);
  background: #fafafa;
}

.total-institutions_governance {
  color: rgba(115, 51, 155, 1);
  background: #fafafa;
}

.total-transport_infrastructure {
  color: rgba(204, 76, 42, 1);
  background: #fafafa;
}

.total-innovation {
  color: rgba(243, 156, 18, 1);
  background: #fafafa;
}

.total-vibrancy {
  color: rgba(39, 174, 96, 1);
  background: #fafafa;
}

.total-e_intelligence {
  color: rgba(142, 68, 173, 1);
  background: #fafafa;
}

.total-future-readiness:hover {
  background: #3ac7ffff;
  cursor: pointer;
  color: white;
}

.total-people_centricity:hover {
  background: rgba(78, 129, 196, 1);
  cursor: pointer;
  color: white;
}

.total-openness:hover {
  background: rgba(102, 173, 93, 1);
  cursor: pointer;
  color: white;
}

.total-sustainability:hover {
  background: rgba(226, 170, 35, 1);
  cursor: pointer;
  color: white;
}

.total-institutions_governance:hover {
  background: rgba(115, 51, 155, 1);
  cursor: pointer;
  color: white;
}

.total-transport_infrastructure:hover {
  background: rgba(204, 76, 42, 1);
  cursor: pointer;
  color: white;
}

.total-innovation:hover {
  background: rgba(243, 156, 18, 1);
  cursor: pointer;
  color: white;
}

.total-vibrancy:hover {
  background: rgba(39, 174, 96, 1);
  cursor: pointer;
  color: white;
}

.total-e_intelligence:hover {
  background: rgba(142, 68, 173, 1);
  cursor: pointer;
  color: white;
}

.stat-header {
  margin-bottom: 0px;
  font-size: small;
  font-weight: 700 !important;
  color: #4a4a4a !important;
}

.country-container {
  padding: 1em;
  border-radius: 0.25rem;
}

.report-stat-box {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  padding: 15px 0;
  text-align: center;
  background: #fafafa;
  margin: 5px 0 5px 0;
  min-height: 90px;
  border-radius: 0.25em;
}

.report-stat-box .field-name {
  font-size: 12px;
  text-transform: uppercase;
  color: #666;
  margin-bottom: 5px;
}

.report-stat-box .field-value {
  font-size: larger;
  font-weight: bold;
  color: #333;
}

.report-stat-box-header {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  padding: 10px 0;
  text-align: center;
  background: #4a4a4a;
  margin: 5px 0 5px 0;
  min-height: 90px;
  border-radius: 0.25em;
  color: white;
}

.report-stat-box-header .field-name {
  font-size: 12px;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.report-stat-box-header .field-value {
  font-size: large;
  font-weight: bold;
}

.city-image-placeholder {
  border: 2px dashed #dee2e6;
}
</style>
